"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standardCashbackTypes = exports.exampleAvatarPath = void 0;
var exampleAvatarPath = 'https://assets.yc.level.travel/static/random_client_pic_06.jpg';
exports.exampleAvatarPath = exampleAvatarPath;
var standardCashbackTypes = ['standard1', 'standard2'];
exports.standardCashbackTypes = standardCashbackTypes;